import { CameraIcon, PrinterIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import { getMinPrices, formatPrice } from "@/utils/wizardPriceUtils";
import PriceDisplay from "@/components/wizard/PriceDisplay";
import OptionCard from "@/components/wizard/OptionCard";
import WizardNavigation from "../WizardNavigation";
import StepHeader from "../StepHeader";

export default function Step1PrintType({ value, onNext, onBack }) {
  const [selectedValue, setSelectedValue] = useState(value || "");
  const [prices, setPrices] = useState({
    minDigitalPrice: null,
    minPrintPrice: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadPrices = async () => {
      const result = await getMinPrices();
      setPrices(result);
      setIsLoading(false);
    };
    loadPrices();
  }, []);

  const handleNext = () => {
    if (selectedValue) {
      onNext({ printType: selectedValue });
    }
  };

  return (
    <div className="space-y-6">
      <StepHeader
        title="Welche Art von Fotobox passt zu deinem Event?"
        description="Sollen deine Gäste ihre Fotos direkt ausgedruckt mitnehmen oder digital erhalten?"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <OptionCard
          isSelected={selectedValue === "print"}
          onClick={() => setSelectedValue("print")}
          icon={PrinterIcon}
          label="Mit Fotodruck"
          description="Gäste nehmen ihre Fotos direkt ausgedruckt mit."
        />
        <OptionCard
          isSelected={selectedValue === "digital"}
          onClick={() => setSelectedValue("digital")}
          icon={CameraIcon}
          label="Nur digital"
          description="Fotos per Online-Galerie oder Download für deine Gäste."
        />
      </div>

      <WizardNavigation
        onBack={onBack}
        onNext={handleNext}
        disableNext={!selectedValue}
      />
    </div>
  );
}
